/**
 * Created by andrey on 25.03.2026
 */

const Pathfinder = function (options) {
    this.cost = options.cost;
    this.stopBefore = options.stopBefore;
};

Pathfinder.IMPASSABLE = 1e9;
Pathfinder.TURN_PENALTY = 0.3;

Pathfinder.prototype.findPath = function (source, target, diagonalMovement) {
    const isTarget = (x, y) => x === target.x && y === target.y;
    const dirs = diagonalMovement ? [Iso.DOWN_RIGHT, Iso.UP_LEFT, Iso.UP_RIGHT, Iso.DOWN_LEFT, Iso.UP_ABOVE, Iso.DOWN_BELOW, Iso.HORIZONTAL_LEFT, Iso.HORIZONTAL_RIGHT] : [Iso.DOWN_RIGHT, Iso.UP_LEFT, Iso.UP_RIGHT, Iso.DOWN_LEFT];
    const NO_FAMILY = -1;
    const familyOf = (dir) => {
        if (dir.x === 0) {
            return 0;
        }
        if (dir.y === 0) {
            return 1;
        }
        return dir.x === dir.y ? 2 : 3;
    };
    const families = dirs.map(familyOf);

    const keyOf = (x, y, family) => `${x}_${y}_${family}`;
    const parseKey = (k) => {
        const [xs, ys] = k.split("_", 3);
        return { x: parseInt(xs), y: parseInt(ys) };
    };

    const heap = [];
    const pushToHeap = (node, distance) => {
        heap.push({ node, distance });
        let i = heap.length - 1;
        while (i > 0) {
            const parent = Math.floor((i - 1) / 2);
            if (heap[parent].distance <= heap[i].distance) {
                break;
            }
            const tmp = heap[parent];
            heap[parent] = heap[i];
            heap[i] = tmp;
            i = parent;
        }
    };
    const popFromHeap = () => {
        const top = heap[0];
        const last = heap.pop();
        if (heap.length) {
            heap[0] = last;
            let i = 0;
            while (true) { // eslint-disable-line no-constant-condition
                const left = i * 2 + 1;
                const right = left + 1;
                let smallest = i;
                if (left < heap.length && heap[left].distance < heap[smallest].distance) {
                    smallest = left;
                }
                if (right < heap.length && heap[right].distance < heap[smallest].distance) {
                    smallest = right;
                }
                if (smallest === i) {
                    break;
                }
                const tmp = heap[smallest];
                heap[smallest] = heap[i];
                heap[i] = tmp;
                i = smallest;
            }
        }
        return top;
    };

    const dist = {};
    const prev = {};

    const start = { x: source.x, y: source.y, family: NO_FAMILY };
    const startKey = keyOf(start.x, start.y, start.family);
    dist[startKey] = 0;
    pushToHeap(start, 0);

    let endKey;

    while (heap.length && !endKey) {
        const { node: step, distance: d } = popFromHeap();
        const stepKey = keyOf(step.x, step.y, step.family);
        if (d !== dist[stepKey]) {
            continue;
        }

        if (isTarget(step.x, step.y)) {
            endKey = stepKey;
            break;
        }

        for (let j = 0; j < dirs.length; j++) {
            const dir = dirs[j];
            const tx = step.x + dir.x;
            const ty = step.y + dir.y;

            const edgeCost = this.cost(tx, ty, step.x, step.y);
            if (edgeCost >= Pathfinder.IMPASSABLE) {
                if (this.stopBefore && this.stopBefore(tx, ty, step.x, step.y)) {
                    endKey = stepKey;
                    break;
                }
                continue;
            }

            const family = families[j];
            const turnPenalty = step.family !== NO_FAMILY && step.family !== family ? Pathfinder.TURN_PENALTY : 0;
            const nextKey = keyOf(tx, ty, family);
            const nextDist = d + edgeCost + turnPenalty;

            if (dist[nextKey] === undefined || nextDist < dist[nextKey]) {
                dist[nextKey] = nextDist;
                prev[nextKey] = stepKey;
                pushToHeap({ x: tx, y: ty, family }, nextDist);
            }
        }
    }

    if (!endKey) {
        return [];
    }

    const path = [];
    for (let k = endKey; k !== undefined; k = prev[k]) {
        const { x, y } = parseKey(k);
        path.push(cc.p(x, y));
    }
    return path.reverse();
};
